var map = {
	"./bn/main.yml": 42,
	"./de/main.yml": 43,
	"./en/main.yml": 44,
	"./es/main.yml": 45,
	"./fr/main.yml": 46,
	"./gd/main.yml": 47,
	"./it/main.yml": 48,
	"./ru/main.yml": 49,
	"./si/main.yml": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;